import styled, { css } from 'styled-components'

const SECTION_GAP = 148

export const Section = styled.section`
  width: 100%;
  margin-top: ${SECTION_GAP}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  @media (max-width: 600px) {
    margin-top: 48px;
    padding-left: 8px;
    padding-right: 8px;
  }
`

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 36px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: var(--blue6, #21105d);
  margin-bottom: 48px;
  @media (max-width: 600px) {
    font-size: 24px;
    margin-bottom: 16px;
  }
`

export const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 34px;
  justify-content: center;
  align-items: center;
  margin-bottom: 48px;
  @media (max-width: 900px) {
    gap: 16px;
    margin-bottom: 26px;
    overflow-x: auto;
    flex-wrap: nowrap;
    width: 100%;
    padding-bottom: 8px;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    justify-content: flex-start;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  &::-webkit-scrollbar {
    display: none;
  }
`

export const Button = styled.button<{ active?: boolean }>`
  height: 57px;
  width: auto;
  border-radius: 10px;
  padding: 16px 21px;
  background: #f7f9fc;
  border: none;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 21px;
  color: var(--blue6);
  cursor: pointer;
  transition:
    background 0.2s,
    color 0.2s;
  text-align: center;
  scroll-snap-align: start;
  white-space: nowrap;
  ${props =>
    props.active &&
    css`
      background: var(--blue6);
      color: var(--light);
    `}
  &:hover {
    background: var(--blue6);
    color: var(--light);
  }
  @media (max-width: 900px) {
    height: 44px;
    padding: 12px 16px;
    font-size: 16px;
  }
`

export const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  margin-top: 48px;
  padding-left: 8px;
  padding-right: 8px;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
    gap: 24px;
    margin-top: 26px;
  }
`

export const TextCol = styled.div`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
  min-width: 280px;
  max-width: 600px;
  @media (max-width: 900px) {
    min-width: unset;
    max-width: unset;
    width: 100%;
    align-items: left;
  }
`

export const Paragraph = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: var(--blue6, #21105d);
  margin: 0;
  @media (max-width: 900px) {
    font-size: 12px;
    line-height: 18px;
  }
`

export const BulletList = styled.ul`
  list-style: disc inside;
  color: #21105d;
  margin: 0;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  & li {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: var(--blue6, #21105d);
    @media (max-width: 900px) {
      font-size: 12px;
      line-height: 18px;
      text-align: left;
    }
  }
  & li::marker {
    color: #21105d;
  }
`

export const ImageCol = styled.div`
  flex: 1 1 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 220px;
  @media (max-width: 900px) {
    width: 100%;
    margin-top: 16px;
    padding-left: 8px;
    padding-right: 8px;
    box-sizing: border-box;
    justify-content: center;
  }
`
